// import React from "react";
// import { Helmet } from "react-helmet";
// import { useLocation } from "react-router-dom";

// const SITE = "https://exploreasiait.com";

// type Props = {
//   title: string;
//   description?: string;
// };

// export function HelmetSeo({ title, description }: Props) {
//   const { pathname, search } = useLocation();
//   const canonical = `${SITE}${pathname}${search}`;

//   return (
//     <Helmet>
//       <title>{title}</title>

//       {description ? <meta name="description" content={description} /> : null}

//       <link rel="canonical" href={canonical} />

//       <meta property="og:type" content="website" />
//       <meta property="og:url" content={canonical} />
//       <meta property="og:title" content={title} />
//       {description ? (
//         <meta property="og:description" content={description} />
//       ) : null}
//     </Helmet>
//   );
// }

import React from "react";
import { Helmet } from "react-helmet";
import { useLocation } from "react-router-dom";

const SITE = "https://clickandchill.online";

type HelmetSeoProps = {
  title: string;
  description?: string;
  keywords?: string;
  ogType?: "website" | "article";
  image?: string;
};

export const HelmetSeo: React.FC<HelmetSeoProps> = ({
  title,
  description,
  keywords,
  ogType = "website",
  image,
}) => {
  const { pathname, search } = useLocation();
  const canonical = `${SITE}${pathname}${search}`;

  return (
    <Helmet>
      <title>{title}</title>

      {description ? <meta name="description" content={description} /> : null}
      {keywords ? <meta name="keywords" content={keywords} /> : null}

      {/* ✅ canonical 超重要 */}
      <link rel="canonical" href={canonical} />

      {/* OpenGraph */}
      <meta property="og:type" content={ogType} />
      <meta property="og:url" content={canonical} />
      <meta property="og:title" content={title} />
      {description ? (
        <meta property="og:description" content={description} />
      ) : null}
      {image ? <meta property="og:image" content={image} /> : null}

      {/* Twitter */}
      <meta
        name="twitter:card"
        content={image ? "summary_large_image" : "summary"}
      />
      <meta name="twitter:title" content={title} />
      {description ? (
        <meta name="twitter:description" content={description} />
      ) : null}
      {image ? <meta name="twitter:image" content={image} /> : null}
    </Helmet>
  );
};
